import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import 'leaflet/dist/leaflet.css';

const DynamicMapContainer = dynamic(() => import('react-leaflet').then((mod) => mod.MapContainer), {
    ssr: false,
});
const DynamicTileLayer = dynamic(() => import('react-leaflet').then((mod) => mod.TileLayer), {
    ssr: false,
});
const DynamicMarker = dynamic(() => import('react-leaflet').then((mod) => mod.Marker), {
    ssr: false,
});
const DynamicPopup = dynamic(() => import('react-leaflet').then((mod) => mod.Popup), {
    ssr: false,
});

// Fix default marker icon issue

const LeafletMap = () => {
    const [isClient, setIsClient] = useState(false);
    const [Leaflet, setLeaflet] = useState(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // Import Leaflet dynamically
            import('leaflet').then((L) => {
                setLeaflet(L);
                // Initialize your map here using L
            });
        }
    }, []);

    useEffect(() => {
        if (Leaflet) {
            setIsClient(true);
            delete Leaflet.Icon.Default.prototype._getIconUrl;
            Leaflet.Icon.Default.mergeOptions({
                iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
                iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
                shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
            });
        }
    }, [Leaflet]);

    const position = [47.92364745270463, 106.91330770959924]; // Default position

    if (!isClient) {
        return null; // Render nothing on the server
    }

    return (
        <DynamicMapContainer center={position} zoom={16} style={{ height: '400px', width: '100%' }}>
            <DynamicTileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <DynamicMarker position={position}>
                <DynamicPopup>
                    Бүсчилсэн хөгжлийн үндэсний
                    <br />
                    хүрээлэн
                </DynamicPopup>
            </DynamicMarker>
        </DynamicMapContainer>
    );
};

export default LeafletMap;
